<template>
  <div class="fixed-nav">
    <b-container>
      <div class="fixed-links">
        <div class="link-container">
          <button
            class="collapse-btn link border-none"
            :class="{isActiveLink: $route.meta.key === 1}"
            @click="toggled = !toggled"
          >Торговым центрам</button>
          <div class="collapse-link" v-show="toggled">
            <button
              class="shop-link"
              :class="{isActiveShopLink: $route.meta.index === 1}"
              @click="push(`autoReg`,2)"
            >Автоматизиованная стойка регистрации</button>
            <button
              class="shop-link"
              :class="{isActiveShopLink: $route.meta.index === 2}"
              @click="push(`independReg`,3)"
            >Самостоятельная регистрация</button>
            <button
              class="shop-link"
              :class="{isActiveShopLink: $route.meta.index === 3}"
              :to="{name: 'brands'}"
              @click="push(`loyalProgram`,4)"
            >Программа лояльностей покупателей ТРЦ</button>
          </div>
        </div>
        <button
          class="link"
          :class="{isActiveLink: $route.meta.key === 2}"
          @click="push(`brands`,5)"
        >FMCG Брендам</button>
        <button
          class="link"
          :class="{isActiveLink: $route.meta.key === 3}"
          @click="push(`franchisors`,6)"
        >Франчайзерам</button>
        <button class="link" v-if="$route.meta.path === 2" @click="push(`products`,2)">Продукты</button>
        <button class="link" v-if="$route.meta.path === 1" @click="push(`blog`,7)">Блог</button>
      </div>
      <div class="lg-appear">
        <div class="mobile">
          <Burger></Burger>
          <div class="articles">
            <a href="tel:+78612923572" class="article">
              <img src="@/assets/images/phone.svg" alt />
              <span>+7 (861) 292-35-72</span>
            </a>
            <a href="mailto:info@event-go.ru" class="article">
              <img src="@/assets/images/mail.svg" alt />
              <span class="mail">info@event-go.ru</span>
            </a>
          </div>
        </div>
      </div>
    </b-container>
    <div class="fixed-bg" v-show="toggled" @click.prevent="toggled = !toggled"></div>
  </div>
</template>

<script>
import ProductsNav from "../components/blog-nav";
import Burger from "./burger";
export default {
  data() {
    return {
      toggled: false
    };
  },
  created() {
    window.addEventListener("scroll", this.fixMenu);
  },
  components: {
    ProductsNav,
    Burger
  },
  methods: {
    push(path, id) {
      if (this.$route.meta.id === id) {
        return;
      } else {
        this.toggled = false;
        window.scrollTo(0, 0);
        this.$router.push({ name: `${path}` });
      }
    },
    fixMenu() {
      let fixedNav = document.querySelector(".fixed-nav");
      let top = 0;
      if (this.$route.meta.path === 1) {
        let heroBlock = document.querySelector(".hero-block");
        top = heroBlock.getBoundingClientRect().top;
      } else {
        let nav = document.querySelector(".products");
        top = nav.getBoundingClientRect().top;
      }
      if (top <= 0) {
        fixedNav.classList.add("fixed-nav-active");
      } else {
        fixedNav.classList.remove("fixed-nav-active");
        this.toggled = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.fixMenu);
  }
};
</script>

